import shortenComments from '@PROJECT_ROOT/assets/shared/js/PrivateAccommodation/shortenComments';
import { heightChanged, legacyHeightChanged } from '@PROJECT_ROOT/assets/shared/js/frameToPartnerMessageTypes';

export default function commentReviews(commentReviewState) {
    shortenComments(150, 'shortenComment', commentReviewState);
    initializeTranslateButtonEvents();
    getMoreReviews(commentReviewState);
}

function initializeTranslateButtonEvents() {
    $(document).on('click', '.translateLink', function switchTranslated() {
        const that = $(this);

        if (that.hasClass('active')) {
            return false;
        }

        const commentContentTranslated = $(`#commentTranslated${that.data('index')}`);
        const commentContentOriginal = $(`#commentOriginal${that.data('index')}`);
        if (that.data('action') === 'translate') {
            commentContentOriginal.addClass('hide');
            commentContentTranslated.removeClass('hide');
        } else if (that.data('action') === 'original') {
            // promijeni klase na originalnom <p> elementu - prikaži original
            commentContentTranslated.addClass('hide');
            commentContentOriginal.removeClass('hide');
        }
        that.parent().find('.translateLink').removeClass('active');
        that.addClass('active');

        return false;
    });

    $(document).on('click', '.translateReplyLink', function switchTranslatedReply() {
        const that = $(this);

        if (that.hasClass('active')) {
            return false;
        }

        const originalReply = $(`#originalReply-${that.data('index')}`);
        const translatedReply = $(`#translatedReply-${that.data('index')}`);
        if (that.data('action') === 'translate') {
            if (undefined !== originalReply && undefined !== translatedReply) {
                originalReply.addClass('hide');
                translatedReply.removeClass('hide');
            }
        } else if (that.data('action') === 'original') {
            // promijeni klase na originalnom <p> elementu - prikaži original
            if (undefined !== originalReply && undefined !== translatedReply) {
                originalReply.removeClass('hide');
                translatedReply.addClass('hide');
            }
        }
        that.parent().find('.translateReplyLink').removeClass('active');
        that.addClass('active');

        return false;
    });
}

function getMoreReviews({ loadCommentsUrl, ...commentReviewState }) {
    // AJAX poziv za učitavanje dodatnih komentara, ako ih ima
    $(document).on('click', '.loadMore', () => {
        $('.loaderBar').show();
        $.get(loadCommentsUrl.replace('__OFFSET__', $('.loadMore').data('offset'))).then((data) => {
            $('.loaderBar').hide();
            if (data === '') {
                return;
            }

            $('.reviewsWrap').append(data.comments);

            if (data.hasMoreComments) {
                $('.loadMore').data('offset', data.nextOffset);
            } else {
                $('.loadMore').hide();
                $('#backOnTop').show();
            }
            shortenComments(150, 'shortenComment', commentReviewState);

            window.parent.postMessage(heightChanged(), '*');
            window.parent.postMessage(legacyHeightChanged(document), '*');
        });
    });
}
